// src/pages/AdminDashboard.jsx
import React, { useState, useEffect } from "react";
import { signOut } from "firebase/auth";
import { auth, db } from "../firebase";
import { useNavigate } from "react-router-dom";
import AdminNavbar from "../components/admin/AdminNavbar";
import RegisterAccount from "../components/admin/RegisterAccount";
import RegisterStudent from "../components/admin/RegisterStudent";
import StudentTable from "../components/admin/StudentTable";
import { collection, getDocs } from "firebase/firestore";

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("registerStudent");
  const [students, setStudents] = useState([]);

  const navigate = useNavigate();

  // ✅ fetch students from Firestore
  const fetchStudents = async () => {
    const querySnapshot = await getDocs(collection(db, "students"));
    const studentList = [];
    querySnapshot.forEach((doc) => {
      studentList.push({ id: doc.id, ...doc.data() });
    });
    setStudents(studentList);
  };

  useEffect(() => {
    fetchStudents();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/"); // ✅ logout goes to home page
  };

  return (
    <div
      className="min-h-screen bg-cover bg-center"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1920&q=80')",
      }}
    >
      <AdminNavbar setActiveTab={setActiveTab} handleLogout={handleLogout} />

      <div className="flex justify-center items-center py-10">
        <div className="bg-white bg-opacity-95 p-8 rounded-xl shadow-lg w-full max-w-5xl">
          {activeTab === "registerAccount" && <RegisterAccount />}
          
          {activeTab === "registerStudent" && (
            <RegisterStudent fetchStudents={fetchStudents} />
          )}

          {activeTab === "students" && (
            <StudentTable students={students} fetchStudents={fetchStudents} />
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
